import React, { useState } from 'react';
import styled from 'styled-components';
import { Path } from '../Routing/Paths';
import Header from './components/Header';
import { themeColor } from '../Theming';
import { useIsIPad } from '../Common/Analytics/utils';

const Container = styled.div<{ isIPad?: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  max-height: 100dvh;
  max-width: ${(props) => (props.isIPad ? '100%' : '600px')};
  margin: 0 auto;
`;

const MainContent = styled.div<{ isIPad?: boolean }>`
  padding: ${(props) =>
    props.isIPad ? '40px 100px 0 100px' : '0px 24px 0 24px'};
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const Title = styled.h1<{ isIPad?: boolean }>`
  font-size: ${(props) => (props.isIPad ? '40px' : '30px')};
  font-weight: 600;
  color: #2d3c46;
  margin-bottom: ${(props) => (props.isIPad ? '30px' : '10px')};
`;

const Paragraph = styled.p<{ isIPad?: boolean }>`
  font-size: ${(props) => (props.isIPad ? '24px' : '18px')};
  line-height: 1.5;
  color: #2d3c46;
  margin: 6px 0;
`;

const Button = styled.button<{ isIPad?: boolean; copied?: boolean }>`
  background-color: ${(props) => (props.copied ? '#4CAF50' : '#2d3c46')};
  height: ${(props) => (props.isIPad ? '80px' : '61px')};
  color: ${themeColor('white')};
  font-size: ${(props) => (props.isIPad ? '24px' : '18px')};
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin: 0 auto;
  width: 100%;
  max-width: ${(props) => (props.isIPad ? '400px' : '300px')};

  &:hover {
    opacity: 0.9;
  }
`;

const BottomContent = styled.div<{ isIPad?: boolean }>`
  padding: ${(props) =>
    props.isIPad ? '0 100px 48px 100px' : '0 24px 32px 24px'};
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

const NTVPluginActivationAlternateBrowser: React.FC = () => {
  const [copied, setCopied] = useState(false);
  const isIPad = useIsIPad();

  const copyLink = () => {
    navigator.clipboard.writeText(
      `${window.location.origin}${Path.NTVPluginActivationHome}`
    );
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1500);
  };

  return (
    <Container isIPad={isIPad}>
      <Header showBrands logoWidth={77} text="ntv Shopping Deals" />
      <MainContent isIPad={isIPad}>
        <Title isIPad={isIPad}>Verwenden Sie einen alternativen Browser?</Title>
        <Paragraph isIPad={isIPad}>
          Wenn Sie beim Online-Shopping sparen möchten, indem Sie unsere neue
          ntv Shopping Deals-Erweiterung installieren, besuchen Sie diese Seite
          bitte in Ihrem Safari-Browser.
        </Paragraph>
        <Paragraph isIPad={isIPad}>
          Kopieren Sie den Link, indem Sie auf die Schaltfläche unten klicken,
          öffnen Sie dann Safari und fügen den Link in die Adressleiste ein.
        </Paragraph>
      </MainContent>
      <BottomContent isIPad={isIPad}>
        <Button isIPad={isIPad} copied={copied} onClick={copyLink}>
          {copied ? 'Link kopiert!' : 'Link kopieren'}
        </Button>
      </BottomContent>
    </Container>
  );
};

export default NTVPluginActivationAlternateBrowser;
